import { replace } from 'react-router-redux'
import { actions } from 'react-redux-form'
import services from 'services'
import tokenStore from 'services/token-store'
import mappers from 'admin/services/mappers'
import { addMessage } from 'actions'
import { logout } from 'actions/session'
import { subscriptionNeeded } from 'admin/actions/billing'
import models from 'admin/models'
import { mapLanguageToComponentProps } from 'admin/i18n'
import { clearIntercomCookies, clearUserDataFromIntercom } from 'chat-bots/intercom'

export default {

  resetState() {
    const { dispatch } = services.store
    dispatch(logout())
    Object.keys(models).forEach((model) => {
      dispatch(actions.reset(model))
      dispatch(actions.setInitial(model))
    })
  },

  forwardToLogin() {
    const { dispatch } = services.store
    dispatch(replace({
      pathname: '/admin/login',
      state: { nextPathname: location.pathname },
    }))
  },

  fetchFavoriteVideos(context) {
    const favoriteContext = !context ? 'user' : context
    return this.fetch(`/v1/admin/favorite-videos/${favoriteContext}`)
      .then(mappers.mapQuestionJsonToModel)
  },

  saveFavoriteVideo(payload, context) {
    const body = {
      video: mappers.mapQuestionModelToJson(payload.video),
      isNewVideo: payload.isNewVideo,
    }
    return this.fetch(`/v1/admin/favorite-videos/${context}`, { method: 'PUT', body })
      .then(mappers.mapQuestionJsonToModel)
  },

  deleteFavoriteVideo(videoId, context) {
    return this.fetch(`/v1/admin/favorite-videos/${context}/${videoId}`, { method: 'DELETE' })
  },

  updateVideo({
    title,
    tags,
    selectedLibrary,
    videoId,
  }) {
    return this.fetch('/v1/admin/videos/update', { method: 'POST', body: {
      title,
      tags,
      selectedLibrary,
      videoId,
    } })
  },

  fetchCompany() {
    return this.fetch('/v1/admin/company')
      .then(mappers.mapCompanyJsonToModel)
  },

  saveCompany(company) {
    const body = mappers.mapCompanyModelToJson(company)
    return this.fetch('/v1/admin/company', { method: 'PUT', body })
      .then(mappers.mapCompanyJsonToModel)
  },

  fetchJobAdApplications(jobAdId) {
    return this.fetch(`/v1/admin/job-ads/${jobAdId}/applications`)
      .then(mappers.mapApplicationJsonToModel)
  },

  changeJobAdStatus(jobAdId, status) {
    return this.fetch(`/v1/admin/job-ads/${jobAdId}/status`, { method: 'PUT', body: { status } })
  },

  changeInterviewStatus(id, status) {
    return this.fetch(`/v1/admin/interviews/${id}/status`, { method: 'PUT', body: { status } })
  },

  createInterview(interviewType, jobAdId) {
    const url = '/v1/admin/interviews'
    const body = { interviewType, jobAdId }
    return this.fetch(url, { method: 'POST', body })
      .then(mappers.mapInterviewJsonToModel)
  },

  saveInterview(interview) {
    const body = mappers.mapInterviewModelToJson(interview)
    return this.fetch(`/v1/admin/interviews/${interview.id}`, { method: 'PUT', body })
      .then(mappers.mapInterviewJsonToModel)
  },

  deleteInterview(interviewId) {
    return this.fetch(`/v1/admin/interviews/${interviewId}`, { method: 'DELETE' })
  },

  search(query, filter) {
    return this.fetch('/v1/admin/search', { method: 'POST', body: { query, filter } })
      .then(({ applications, candidates }) => ({
        applications: {
          ...applications,
          data: mappers.mapApplicationJsonToModel(applications.data),
        },
        candidates: {
          ...candidates,
          data: mappers.mapCandidateJsonToModel(candidates.data),
        },
      }))
  },

  fetch(url, params) {
    return services.fetch(url, params)
      .catch((error) => {
        const { dispatch, getState } = services.store
        const { i18n } = mapLanguageToComponentProps()(getState())
        const { pathname } = location
        const { messages, language } = getState().global
        if ('response' in error && error.response.status === 401) {
          tokenStore.removeToken()
          clearUserDataFromIntercom(language)
          clearIntercomCookies(true)
          this.resetState()

          // forward to login only if not already on the login page
          if (pathname !== '/admin/login') {
            this.forwardToLogin()
          }

          // show error message only if not shown yet
          const sessionExpiredMessages = messages.filter(m => m.text === i18n.session.expired)
          if (sessionExpiredMessages.length < 1) {
            dispatch(addMessage({ style: 'danger', text: i18n.session.expired }))
          }
        } else if ('response' in error && error.response.status === 402) {
          dispatch(subscriptionNeeded(true))
        } else if ('response' in error && (error.response.status === 403 || error.response.status === 404)) {
          const { dispatch } = services.store
          dispatch(replace({
            pathname: `/${error.response.status}`,
            state: { nextPathname: location.pathname },
          }))
        }
        throw error
      })
  },

}
